import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ILoadingSpinnerState, state } from './state';

export const NAME = 'loadingSpinner';

export const store: Module<ILoadingSpinnerState, IRootState> = {
    actions,
    getters,
    modules: {},
    mutations,
    namespaced: true,
    state
};

export default store;
